import {AuthTokens} from '../types';

type TokenTemplate = {
  encodedHeader: string;
  payload: Record<string, string | number> & {exp: number};
  encodedSign: string;
};

const refreshTokenTemplate: TokenTemplate = {
  encodedHeader: 'eyJhbGciOiJIUzI1NiJ9',
  payload: {
    iss: 'shifter:access',
    exp: 0,
    sub: 'budbuddy',
    username: 'budbuddy',
    userid: 57666,
  },
  encodedSign: 'CxDdFA-YKZUGVb1TigClmrhgEHo2idkWUFKY8iXuoes',
};

const accessTokenTemplate: TokenTemplate = {
  encodedHeader: 'eyJhbGciOiJIUzI1NiJ9',
  payload: {
    iss: 'shifter:access',
    exp: 0,
    sub: 'budbuddy',
    username: 'budbuddy',
    userid: 57666,
    firstname: 'BudBuddy',
    lastname: 'Demo',
    language: 'no',
  },
  encodedSign: 'CxDdFA-YKZUGVb1TigClmrhgEHo2idkWUFKY8iXuoes',
};

const getExpiration = (lifetime: number): number =>
  Math.floor(Date.now() / 1000) + lifetime;

const getToken = (lifetime: number, template: TokenTemplate): string => {
  const payload = {...template.payload};
  payload.exp = getExpiration(lifetime);
  const jsonPayload = JSON.stringify(payload);
  const encodedPayload = btoa(jsonPayload).slice(0, -1);
  const token = [
    template.encodedHeader,
    encodedPayload,
    template.encodedSign,
  ].join('.');
  return token;
};

export const generateMockTokenSet = (
  accessTokenLifetime: number,
  refreshTokenLifetime: number,
): AuthTokens => {
  console.log(
    'generateMockTokenSet:',
    accessTokenLifetime,
    ':',
    refreshTokenLifetime,
  );
  return {
    accessToken: getToken(accessTokenLifetime, accessTokenTemplate),
    refreshToken: getToken(refreshTokenLifetime, refreshTokenTemplate),
  };
};
